var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07031 0.472656C3.65031 0.472656 0.0703125 2.26266 0.0703125 4.47266V14.4727C0.0703125 16.6827 3.66031 18.4727 8.07031 18.4727C12.4803 18.4727 16.0703 16.6827 16.0703 14.4727V4.47266C16.0703 2.26266 12.4903 0.472656 8.07031 0.472656ZM14.0703 14.4727C14.0703 14.9727 11.9403 16.4727 8.07031 16.4727C4.20031 16.4727 2.07031 14.9727 2.07031 14.4727V12.2427C3.68031 13.0227 5.79031 13.4727 8.07031 13.4727C10.3503 13.4727 12.4603 13.0227 14.0703 12.2427V14.4727ZM14.0703 9.92266C12.7703 10.8727 10.4903 11.4727 8.07031 11.4727C5.65031 11.4727 3.37031 10.8727 2.07031 9.92266V7.11266C3.54031 7.94266 5.68031 8.47266 8.07031 8.47266C10.4603 8.47266 12.6003 7.94266 14.0703 7.11266V9.92266ZM8.07031 6.47266C4.20031 6.47266 2.07031 4.97266 2.07031 4.47266C2.07031 3.97266 4.20031 2.47266 8.07031 2.47266C11.9403 2.47266 14.0703 3.97266 14.0703 4.47266C14.0703 4.97266 11.9403 6.47266 8.07031 6.47266Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.661a26f7.svg";
export { ForwardRef as ReactComponent };